module.exports = __webpack_public_path__ + "static/media/shipBackgroundPic.e9c2597f.jpg";